var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_277",
    "data-name": "Rectangle 277",
    width: 24,
    height: 24,
    transform: "translate(7 7)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(-7 31) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_276",
    "data-name": "Rectangle 276",
    width: 49.143,
    height: 49.143,
    rx: 4.5,
    transform: "translate(1.495 2.785)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "radio_button_unchecked_FILL0_wght400_GRAD0_opsz48",
    d: "M91.5,198.992a11.123,11.123,0,0,0,4.455-.905,11.582,11.582,0,0,0,6.136-6.136,11.483,11.483,0,0,0,0-8.938,11.489,11.489,0,0,0-2.472-3.65,11.784,11.784,0,0,0-3.664-2.457,11.483,11.483,0,0,0-8.938,0,11.478,11.478,0,0,0-6.107,6.107,11.483,11.483,0,0,0,0,8.938,11.784,11.784,0,0,0,2.457,3.664,11.489,11.489,0,0,0,3.65,2.472A11.194,11.194,0,0,0,91.5,198.992Zm0-1.724a9.763,9.763,0,1,1,6.912-2.86A9.4,9.4,0,0,1,91.5,197.267ZM91.5,187.5Z",
    transform: "translate(-72.992 -168)",
    fill: "#918f90"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleOutline);
export default __webpack_public_path__ + "static/media/circle_outline.3471cb0037f4c18fbefd2d26c0f49743.svg";
export { ForwardRef as ReactComponent };